import { App } from "./typings/App";
import { configs as configWMS } from "./src_wms/index";

export const apps: App[] = [configWMS()];
